import type { ListingPage } from '../model';

export const REQUEST_STATE_INJECTION =
  'productDiscovery/Listing/REQUEST_STATE_INJECTION';
export const STATE_INJECTED = 'productDiscovery/Listing/STATE_INJECTED';
export const RESET_INJECTION_STATE = 'productDiscovery/Listing/RESET_INJECTION';

interface RequestInjection {
  type: typeof REQUEST_STATE_INJECTION;
  pageName: ListingPage;
}

export const requestStateInjection = (
  pageName: ListingPage,
): RequestInjection => ({
  type: REQUEST_STATE_INJECTION,
  pageName,
});

interface Injected {
  type: typeof STATE_INJECTED;
  pageName: ListingPage;
}
export const stateInjected = (pageName: ListingPage): Injected => ({
  type: STATE_INJECTED,
  pageName,
});

interface ResetInjectionState {
  type: typeof RESET_INJECTION_STATE;
  pageName: ListingPage;
}
export const resetInjectionState = (
  pageName: ListingPage,
): ResetInjectionState => ({
  type: RESET_INJECTION_STATE,
  pageName,
});

export type Actions = RequestInjection | Injected | ResetInjectionState;
